import { httpFormData, httpJson } from './http';
export class ApiClient {
    baseUrl;
    auth;
    constructor(baseUrl, auth) {
        this.baseUrl = baseUrl;
        this.auth = auth;
    }
    get(path) {
        return httpJson(`${this.baseUrl}${path}`, {
            method: 'GET',
            auth: this.auth,
        });
    }
    post(path, json) {
        return httpJson(`${this.baseUrl}${path}`, {
            method: 'POST',
            json,
            auth: this.auth,
        });
    }
    patch(path, json) {
        return httpJson(`${this.baseUrl}${path}`, {
            method: 'PATCH',
            json,
            auth: this.auth,
        });
    }
    delete(path) {
        return httpJson(`${this.baseUrl}${path}`, {
            method: 'DELETE',
            auth: this.auth,
        });
    }
    postFormData(path, formData) {
        return httpFormData(`${this.baseUrl}${path}`, formData, {
            method: 'POST',
            auth: this.auth,
        });
    }
}
